import { render, staticRenderFns } from "./topUpdetail.vue?vue&type=template&id=453788aa&"
import script from "./topUpdetail.vue?vue&type=script&lang=js&"
export * from "./topUpdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports